module.exports = __webpack_public_path__ + "img/complaint-callcenter.0362bb81.png";